import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title",
  id: "dictionary-room-modal-label"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-title",
  id: "add-room-item-modal-label"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Name", -1)
const _hoisted_12 = { class: "col-sm-9" }
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Category", -1)
const _hoisted_15 = { class: "col-sm-9" }
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Priority", -1)
const _hoisted_18 = { class: "col-sm-9" }
const _hoisted_19 = { class: "modal-footer" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]

import $ from 'jquery';
import { snakeCase } from "lodash";
import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import { DictionaryRoom } from "@/models";
import { useToast } from "vue-toastification";

export default /*#__PURE__*/_defineComponent({
  __name: 'DictionaryRoomModal',
  props: {
    id: {},
    operation: {}
  },
  setup(__props: any, { expose: __expose }) {

const store = useStore();
const toasted = useToast();
const actProperty: any = inject('actProperty');
const rooms = computed(() => store.getters['customerdictionary/rooms'] as DictionaryRoom[]);
const selectedroom = computed(() => store.getters['customerdictionary/selectedroom'] as DictionaryRoom);
const categoryOptions = ref([1, 2, 3, 4]);
const priorityOptions = ref([1, 2, 3]);
// Define props
const props = __props;

const addToRooms = async (flag: unknown) => {
  await store.dispatch('customerdictionary/addToRooms', flag);
};

const removeFromRooms = async (flag: unknown) => {
  await store.dispatch('customerdictionary/removeFromRooms', flag);
};

const setCustomerdictionaryDeep = async (payload: { path: string; data: any; }) => {
  await store.dispatch('customerdictionary/setCustomerdictionaryDeep', payload);
};

const setSelectedMaintenanceflag = (room: DictionaryRoom) => {
  store.commit('customerdictionary/setSelectedRoom', room);
};

const category = computed({
  get: () => selectedroom.value.category,
  set: (value: number) => {
    if (value) selectedroom.value.category = value;
  }
});

const priority = computed({
  get: () => selectedroom.value.priority,
  set: (value: number) => {
    if (value) selectedroom.value.priority = value;
  }
});

const onSelectCategory = (value: number) => {
  selectedroom.value.category = value;
};

const onSelectPriority = (value: number) => {
  selectedroom.value.priority = value;
};

const canAdd = () => {
  return selectedroom.value.name ? true : false;
};

const add = () => {
  selectedroom.value.slug = snakeCase(selectedroom.value.name);
  addToRooms(selectedroom.value)
    .then(() => toasted.success(`Added "${selectedroom.value.name}"`))
    .then(() => reset())
    .catch((err: any) => {
      actProperty.displayError(err);
    });
  hide();
};

const save = () => {
  let index = rooms.value.findIndex((f) => f.slug == selectedroom.value.slug);
  if (index >= 0) {
    selectedroom.value.slug = snakeCase(selectedroom.value.name);
    setCustomerdictionaryDeep({
      path: `rooms[${index}]`,
      data: selectedroom.value,
    })
      .then(() => toasted.warning(`Locally saved "${selectedroom.value.name}. Please remember to press final Save"`))
      .then(() => reset())
      .catch((err: any) => {
        actProperty.displayError(err);
      });
  }

  hide();
};

const reset = () => {
  setSelectedMaintenanceflag(new DictionaryRoom());
  hide();
};

const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.id}`).show();
  }
}
const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
    $(`#${props.id}`).hide();
  }
};
__expose({ add, show, hide });

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`dictionary-room-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.operation == 'add')
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, " New Room "))
            : (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(selectedroom.value.name), 1)),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedroom.value.name) = $event))
                }, null, 512), [
                  [_vModelText, selectedroom.value.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_singleselect_text, {
                  modelValue: category.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((category).value = $event)),
                  options: categoryOptions.value,
                  onSelect: onSelectCategory
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_singleselect_text, {
                  modelValue: priority.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((priority).value = $event)),
                  options: priorityOptions.value,
                  onSelect: onSelectPriority
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-auto",
            "data-dismiss": "modal",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (reset()), ["prevent"]))
          }, " Back "),
          (_ctx.operation == 'add')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "submit",
                class: "btn btn-primary",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (add()), ["prevent"])),
                disabled: !canAdd()
              }, " Add room ", 8, _hoisted_20))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "submit",
                class: "btn btn-primary",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (save()), ["prevent"])),
                disabled: !canAdd()
              }, " Ok ", 8, _hoisted_21))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})